var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2354 5.26166C11.2354 5.26166 11.6104 5.63666 11.9854 6.38666C11.9854 6.38666 13.1765 4.51166 14.2354 4.13666",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49614 1.51599C5.62228 1.43666 4.17459 1.65252 4.17459 1.65252C3.26045 1.71788 1.50859 2.23037 1.50861 5.22339C1.50862 8.19096 1.48923 11.8495 1.50861 13.3079C1.50861 14.199 2.06033 16.2775 3.96995 16.3888C6.29107 16.5243 10.4721 16.5531 12.3903 16.3888C12.9039 16.3599 14.6135 15.9568 14.8299 14.0967C15.054 12.1697 15.0094 10.8305 15.0094 10.5118",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 5.26166C16.4999 7.33272 14.8194 9.01169 12.7463 9.01169C10.6732 9.01169 8.99268 7.33272 8.99268 5.26166C8.99268 3.19059 10.6732 1.51166 12.7463 1.51166C14.8194 1.51166 16.4999 3.19059 16.4999 5.26166Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23535 9.76172H8.23533",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23535 12.7617H11.2353",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankApproval);
export default __webpack_public_path__ + "static/media/bank-approval.8ec6121c2a3c598e17baa895535df914.svg";
export { ForwardRef as ReactComponent };